import TableCell from "./TableCell";
import {makeStyles} from "@material-ui/core";
import {MoreVertOutlined} from "@material-ui/icons";
import React from "react";

const useStyles = makeStyles(() => ({
    trMenu: {
        position: 'absolute',
        width: 40,
        left: -42,
        top: 0,
        borderTop: '1px',
        borderBottom: '1px',
        borderLeft: '1px',
        borderStyle: "solid",
        borderColor: "#dedede",
        height: '95%',
        borderRadius: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    rowMenu: {
        visibility: 'hidden'
    },
    tr: {
        position: 'relative',
        '& $rowMenu': {
            visibility: 'hidden',
        },
        '&:hover': {
            '& $rowMenu': {
                visibility: 'visible',
            }
        }
    }
}))
const TableRow = ({component, rowIndex, actionsContext, containerArrayPath, allowActions}) => {
    const classes = useStyles();

    return (
        <>
            <tr className={classes.tr}>
                {allowActions && (
                    <>
                        {rowIndex === 0 ? (
                                <th
                                    className={'sb-table-rendering-th'}
                                    style={{
                                        width: 20,
                                        border: "none"
                                    }} colSpan={1}></th>
                            ) :
                            (
                                <th style={{
                                    width: 20,
                                    border: "none"
                                }}
                                    colSpan={1}
                                >
                                    <div className={classes.rowMenu}>
                                        <MoreVertOutlined fontSize={"small"}/>
                                    </div>

                                </th>
                            )}
                    </>
                )}
                {component.children.map((component, index) => {
                    return (
                        <TableCell
                            key={index}
                            rowIndex={rowIndex}
                            component={component}
                            actionsContext={actionsContext}
                            containerArrayPath={containerArrayPath}
                        />
                    )
                })}
            </tr>
        </>

    )
}

export default TableRow
